import axios from "axios"

export const genereteKey = () => Math.floor(Math.random() * Math.floor(100000000));

export const getUserIp = async () => {
  const res = await axios.get("https://api.db-ip.com/v2/free/self")
  return (res?.data?.countryCode && res.data.countryCode.toLowerCase()) || "UA"
}